export default "__VITE_ASSET__DBMlEbjC__"